import React, { useState } from "react";
import WorkEntry from "./WorkEntry";

const WorkForm = () => {
  const [workEntries, setWorkEntries] = useState([
    {
      type_of_work: "",
      work_description: "",
      building: "",
      level: "",
      rack_number: "",
      remarks: "",
      work_order_number: "",
      work_completion_percentage: "",
      qty: "",
    },
  ]);

  const [formData, setFormData] = useState({
    work_date: "",
    work_supervisor: "",
    work_entries: workEntries,
  });

  const [isSubmitting, setIsSubmitting] = useState(false); // Track submission state

  const handleAddEntry = () => {
    setWorkEntries([
      ...workEntries,
      {
        type_of_work: "",
        work_description: "",
        building: "",
        level: "",
        rack_number: "",
        remarks: "",
        work_order_number: "",
        work_completion_percentage: "",
        qty: "",
      },
    ]);
  };

  const handleDeleteEntry = (index) => {
    if (workEntries.length > 1) {
      setWorkEntries(workEntries.filter((_, i) => i !== index));
    } else {
      alert("At least one work entry must remain.");
    }
  };

  const handleEntryChange = (index, field, value) => {
    const updatedEntries = [...workEntries];
    updatedEntries[index][field] = value;
    setWorkEntries(updatedEntries);
  };

  const handleFormChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true); // Disable the submit button

    const data = {
      ...formData,
      work_entries: workEntries, // Ensure work_entries are passed correctly
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}work/submit-form`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });
      const result = await response.json();
      alert(result.message);
      
      // Optionally, reset the form after successful submission
      setWorkEntries([
        {
          type_of_work: "",
          work_description: "",
          building: "",
          level: "",
          rack_number: "",
          remarks: "",
          work_order_number: "",
          work_completion_percentage: "",
          qty: "",
        },
      ]);
      setFormData({
        work_date: "",
        work_supervisor: "",
        work_entries: [
          {
            type_of_work: "",
            work_description: "",
            building: "",
            level: "",
            rack_number: "",
            remarks: "",
            work_order_number: "",
            work_completion_percentage: "",
            qty: "",
          },
        ],
      });
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("An error occurred while submitting the form.");
    } finally {
      setIsSubmitting(false); // Re-enable the submit button
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {/* Date Input */}
      <div>
        <label className="block text-sm font-medium text-gray-700">Work Date</label>
        <input
          type="date"
          value={formData.work_date}
          onChange={(e) => handleFormChange("work_date", e.target.value)}
          className="block w-full p-2 mt-1 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
          required
        />
      </div>

      {/* Work Entries */}
      {workEntries.map((entry, index) => (
        <WorkEntry
          key={index}
          index={index}
          entry={entry}
          onDelete={handleDeleteEntry}
          onChange={handleEntryChange}
        />
      ))}

      {/* Add New Button */}
      <button
        type="button"
        onClick={handleAddEntry}
        className="w-full px-4 py-2 text-white bg-indigo-600 rounded-md hover:bg-indigo-700"
      >
        Add New
      </button>

      {/* Supervisor */}
      <div>
        <label className="block text-sm font-medium text-gray-700">Work Supervisor</label>
        <select
          value={formData.work_supervisor}
          onChange={(e) => handleFormChange("work_supervisor", e.target.value)}
          className="block w-full p-2 mt-1 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
        >
          <option value="">Select</option>
          <option value="Nusri">Nusri</option>
          <option value="Rimsan">Rimsan</option>
          <option value="Yasir">Yasir</option>
        </select>
      </div>

      {/* Submit Button */}
      <button
        type="submit"
        className="w-full px-4 py-2 text-white bg-green-600 rounded-md hover:bg-green-700"
        disabled={isSubmitting} // Disable button while submitting
      >
        {isSubmitting ? "Submitting..." : "Submit"}
      </button>
    </form>
  );
};

export default WorkForm;
